import React from 'react';

interface NamedEntityIconProps {
  style?: React.CSSProperties;
}

const NamedEntityIcon: React.FC<NamedEntityIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 25.98 30">
      <title>Named Entity Recognition</title>
      <path
        d="M0 22.5l7.095 2.712L12.99 30l12.99-7.5-1.2-7.5 1.2-7.5L12.99 0 7.095 4.788 0 7.5v15z"
        fill="#6A11EA"
      />
      <path d="M17.322 22.5l4.329-7.5L12.99 0 0 7.5l8.661 15h8.661z" fill="#943CFF" />
      <path d="M4.329 15l4.332 7.5H25.98v-15H8.661L4.329 15z" fill="#DD45D3" />
      <path d="M17.322 7.5H8.661L0 22.5 12.99 30l8.661-15-4.329-7.5z" fill="#FD9D52" />
      <path d="M8.661 7.5L4.329 15l4.332 7.5h8.661l4.329-7.5-4.332-7.5H8.661z" fill="#fff" />
      <path d="M12.99 16.95a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z" fill="#FD9D52" />
    </svg>
  );
};

export default NamedEntityIcon;
